import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'horizontal';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group flex gap-4 bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 p-3"
      >
        <div className="w-28 h-20 sm:w-36 sm:h-24 flex-shrink-0 rounded-lg overflow-hidden">
          <img
            src={article.cover}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{article.summary}</p>
          <div className="flex items-center gap-3 mt-2">
            <span className="text-xs text-foreground-400">{article.publishDate}</span>
            <span className="text-xs text-foreground-400">{article.readTime}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.cover}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          {article.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 text-xs font-medium">
              {tag}
            </span>
          ))}
        </div>
        <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{article.summary}</p>
        <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/70">
          <span className="text-xs text-foreground-400">{article.author}</span>
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
      </div>
    </Link>
  );
}